import { LandingPageEffects } from './landing-page.effects';

export const effects: any[] = [LandingPageEffects];
